@if (authored?.length > 0) {
  <ul class="ib">
    @for (person of authored.slice(0, 2); track person; let i = $index) {
      <li class="par--small ib" data-dgat="orgPlanManager-2f0">
        <a
          target="_blank"
          [attr.href]="'/' + person.vanityUrl"
          data-dgat="orgPlanManager-118"
          class="uhover"
          >{{ person.name }}</a
        >
        @if (authored.length > 0 && i < authored.length - 1) {
          <span>,&nbsp;</span>
        }
        @if (authored.length > 2 && i == 1) {
          <span class="ib rel">
            <button
              [dgxPopoverTrigger]="moreAuthors"
              class="v-bottom color-ebony underline"
              data-dgat="orgPlanManager-67e"
            >
              @if (authored.length - 2 === 1) {
                {{ 'dgManagePathways_OneMoreAuthor' | translate }}
              }
              @if (authored.length - 2 !== 1) {
                {{
                  'dgManagePathways_MoreAuthorsFormat'
                    | translate: { count: authored.length - 2 }
                }}
              }
            </button>
            <dgx-popover #moreAuthors placement="bottom">
              <ul role="menu">
                @for (author of authored; track author) {
                  <li
                    data-dgat="personPopover-c99"
                    class="border-bottom"
                    role="menuitem"
                  >
                    <a
                      target="_blank"
                      [attr.href]="'/' + author.vanityUrl"
                      data-dgat="orgPlanManager-118"
                      class="guts-p-v-1 guts-p-h-1 guts-p-h-quart ib"
                      >{{ author.name }}</a
                    >
                  </li>
                }
              </ul>
            </dgx-popover>
          </span>
        }
      </li>
    }
  </ul>
}
